module.exports = __webpack_public_path__ + "1a45a90f.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/clipboard.png
// module id = 1166
// module chunks = 0 1 2